import {Companies} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getCompanies(context, pagination) {
        return Companies.getCompanies(pagination).then((response) => {
            return response.data;
        });
    },
    getCompany(context, id) {
        return Companies.get({id}).then((response) => {
            return response.data;
        });
    },
    createCompany(context, item) {
        return Companies.create(item).then((response) => {
            return response.data;
        });
    },
    updateCompany(context, item) {
        return Companies.update(item).then((response) => {
            return response.data;
        });
    },
    destroyCompany(context, item) {
        return Companies.destroy(item).then((response) => {
            return response.data;
        });
    },
    getCompanyField(context, item) {
        return Companies.getCompanyField(item).then((response) => {
            return response.data;
        });
    },

    getCompanyFieldPublic(context, item) {
        return Companies.getCompanyFieldPublic(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
